module.exports = __webpack_public_path__ + "assets/ned.123024f1.svg";